import { buildTemplatesUrl } from '../../../../global/utils/templateParams';
import { UseCaseSelection } from '../type';
import { TransformedSubUseCase } from '../utils';

export const buildSubUseCaseUrl = (
  currentSelection: UseCaseSelection,
  subUseCase: TransformedSubUseCase
) =>
  buildTemplatesUrl(
    currentSelection.categorySlug,
    currentSelection.subCategorySlug,
    subUseCase.parentUseCaseSlug,
    subUseCase.shortName
  );

export const buildSubUseCaseUrlToggleUrl = (
  currentSelection: UseCaseSelection
) =>
  buildTemplatesUrl(
    currentSelection.categorySlug,
    currentSelection.subCategorySlug,
    currentSelection.useCaseSlug
  );
